import React, { useState, useEffect,useContext  } from 'react';
import { FaBars } from 'react-icons/fa';
import { FaShoppingCart } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import {  Button,Icon } from "element-react";
import {  CartContext } from '../contexts/CartContext'


import {
  MobileIcon,
  NavActions,
  CartLink,
  CartCount,
  Nav,
  NavbarContainer,
  NavLinktest,
  NavItem,
  NavLogo,
  NavMenu,
  NavBtn
} from './NavbarElements';

const Navbar = ({ toggle ,user,  handleSignout, handleSignin }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const {itemCount} = useContext(CartContext);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {

    let isMounted = true;
    if (isMounted) {
      window.addEventListener('scroll', changeNav);
    }
    return () => {
      isMounted = false
    }
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#01bf71' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo onClick={toggleHome} to='/'>
              <span className="app-title">
                Bombay Trading Co
              </span>
            </NavLogo>

            <NavMenu>
              <NavItem>
              <NavLinktest scrollNav={scrollNav} to="/about" >

                         About
                </NavLinktest >

              </NavItem>
              <NavItem>
              <NavLinktest scrollNav={scrollNav} to="/Discover" >

                   Discover
          </NavLinktest >

              </NavItem>
              <NavItem>
                <NavLinktest scrollNav={scrollNav} to="/profile" >
                    <Icon name="setting" />
                         Profile
                </NavLinktest >
              </NavItem>
            </NavMenu>

            <NavActions>
              <CartLink to='/cart' aria-label={`Cart, ${itemCount} items`}>
                <FaShoppingCart />
                {itemCount > 0 && <CartCount>{itemCount}</CartCount>}
              </CartLink>

              {!user ? (
              <NavBtn>
                <Button type="success"   onClick={handleSignin} >Sign In</Button>
              </NavBtn>) :
              (
              <NavBtn>
                <Button type="success" onClick={handleSignout} >Sign Out</Button>
              </NavBtn>

              ) }

              <MobileIcon type="button" onClick={toggle} aria-label="Open menu">
                <FaBars />
              </MobileIcon>
            </NavActions>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
